import React from 'react';
import PropTypes from 'prop-types';
import Button from '@/modules/common/components/Button';

const UploadButton = (props) => {
    return (
        <label htmlFor={props.id}>
            <input id={props.id} type="file"
                   style={{display: 'none'}}
                   onChange={props.onChange}
                   {...props.inputProps}
            />
            <Button component="span" {...props.buttonProps}>{props.children}</Button>
        </label>
    );
};

UploadButton.propTypes = {
    id: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    inputProps: PropTypes.object,
    buttonProps: PropTypes.object,
};

UploadButton.defaultProps = {
    inputProps: {},
    buttonProps: {},
};

export default UploadButton;
